import { getAgentFirstName } from '@common/helpers/community';
import { getAgentUrl } from '@common/helpers/url';
import cx from 'classnames';
import AgentImage from 'sly/agentsAgentPage/AgentProfilePage/AgentProfilePageSummaryWrapper/AgentProfilePageSummary/AgentImage';
import { AgentProfilePageSummaryProps } from 'sly/agentsAgentPage/AgentProfilePage/AgentProfilePageSummaryWrapper/AgentProfilePageSummary/AgentProfilePageSummary.types';
import AgentProfileText from 'sly/agentsAgentPage/AgentProfilePage/AgentProfilePageSummaryWrapper/AgentProfilePageSummary/AgentProfileText';
export default function AgentProfilePageSummary({
  agent,
  buttonHref,
  className,
  heading,
  onAskAgentQuestion,
  toAgentPage,
}: AgentProfilePageSummaryProps) {
  const agentUrl = toAgentPage ? getAgentUrl(agent) : '';
  return (
    <div
      className={cx(
        'flex flex-col gap-x-12',
        'shadow-[rgb(0_0_0_/_20%)_0px_3px_3px_-2px] md:p-12 ',
        'md:shadow-[rgb(0_0_0_/_20%)_0px_3px_3px_-2px,_rgb(0_0_0_/_14%)_0px_3px_4px_0px,_rgb(0_0_0_/_12%)_0px_1px_8px_0px]',
        'lg:flex-row',
        className
      )}
      data-tp-id='gen-div-8f4685f6-5386-4458-9fe9-736020af8ba2'
    >
      <AgentImage
        gallery={agent.gallery}
        displayName={agent.info.displayName}
        agentUrl={agentUrl}
      />
      <AgentProfileText
        displayName={agent.info.displayName}
        ratingValue={agent.aggregateRating.ratingValue}
        numRatings={agent.aggregateRating.numRatings}
        recentFamiliesHelped={agent.info.recentFamiliesHelped}
        operatingIn={agent.info.serviceArea.operatingIn ?? ''}
        showAskQuestionButton
        experience={agent.info.inBusinessSince}
        withSeniorlySince={agent.info.withSeniorlySince}
        buttonHref={buttonHref}
        agentFirstName={getAgentFirstName(agent)}
        heading={heading}
        onAskAgentQuestion={onAskAgentQuestion}
        agentUrl={agentUrl}
        linkHref='#reviews'
        agentSlug={agent.id}
      />
    </div>
  );
}
